import Model from 'flarum/common/Model';

export default class ApplicationKey extends Model {
    usedAt = Model.attribute('used_at', Model.transformDate);
    seconds = Model.attribute('seconds');
    userId = Model.attribute('user_id');

    protected apiEndpoint(): string {
        return '/applications/keys' + ('id' in this.data ? '/' + this.data.id : '');
    }
}
